// extracted by mini-css-extract-plugin
export var auto = "_47-1";
export var spinner = "_47-0";